import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../../../modules/infra/i18n';
import CustomAmountInput from '../containers/CustomAmountInput';
import Modal from '../../Modal';

const AmountModal = ({
  max,
  onCustomSubmit,
  close,
}) => (
  <Modal title={t('common:refund_modal.choose_amount_title')} close={close} showCloseButton>
    <div className="u-pv u-ph++">
      <CustomAmountInput
        onSubmit={onCustomSubmit}
        defaultValue={max}
        max={max}
      />
    </div>
  </Modal>
);
AmountModal.propTypes = {
  max: PropTypes.number.isRequired,
  onCustomSubmit: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
};

export default AmountModal;
